import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import LoginBackgroundDesign from "../../../assets/images/background_design_login";
import Logo from "../../../assets/images/logo"
import ForgotPasswordUpdateFormContainer from "./forms/forgot_password_update_form_container";

class ForgotPasswordUpdate extends React.Component {
  constructor(props) {
    super(props);
  }

  // componentDidMount() {
  //   this.props.loginModal()
  // }

  render() {

    return (
      <div className="loginContainer">
        <img className="loginBackgroundDesign" src={LoginBackgroundDesign} />
        <div className="modernAnglesLoginAndLogo">
          <img className="modernAnglesLoginLogo" src={Logo} onClick={() => this.props.history.push("/")}/>
          <ForgotPasswordUpdateFormContainer />
        </div>
      </div>
    )
  }
}

export default withRouter(ForgotPasswordUpdate);